import { MessageComposeProps } from "components/messages/types";
import {
    ComposeMessageQuery,
    SpecialCommunityComparisonDefaults,
} from "generated/graphql";

export const getComposeMessageComponentProps = (
    props: MessageComposeProps,
    composeMessage: ComposeMessageQuery["composeMessage"],
): MessageComposeProps & {
    recipients: string[];
    initialRecipients?: string[];
    specialCommunityComparisonDefaults: SpecialCommunityComparisonDefaults | null;
    files: ComposeMessageQuery["composeMessage"]["files"];
} => {
    if (composeMessage.recipientSuggestions?.length > 0) {
        return {
            ...props,
            recipients: composeMessage.recipientSuggestions,
            initialRecipients: props.initialRecipients ?? composeMessage.recipients,
            specialCommunityComparisonDefaults:
                composeMessage.specialCommunityComparisonDefaults,
            files: composeMessage.files,
        };
    }

    return {
        ...props,
        recipients: composeMessage.recipients,
        files: composeMessage.files,
        specialCommunityComparisonDefaults:
            composeMessage.specialCommunityComparisonDefaults,
    };
};
